import { Box } from '@mui/material'

export default function NotFound() {
  return (
    <Box padding={2} fontSize="3rem" fontWeight="bold">
      Resource not found
    </Box>
  )
}
